<input [autocomplete]="autocomplete ? 'on' : 'off'"
       type="text" class="form-control"
       [id]="id" [formControl]="control" (blur)="onTouched($event)"
       [readonly]="readonly" [placeholder]="placeholder" [maxlength]="maxlength">
